import React from "react";
import AddTable from "./AddTable";

const Table = () => {
  return (
    <div className="px-4 py-4">
      <AddTable />
    </div>
  );
};

export default Table;
